// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BJ9rbX6kOApAQ1TI_wmw {

    margin-top: 1rem;

    display: flex;

    height: -moz-fit-content;

    height: fit-content;

    width: 100%;

    align-items: center;

    gap: 1rem;

    border-radius: 5px;

    --tw-bg-opacity: 1;

    background-color: rgb(243 202 202 / var(--tw-bg-opacity, 1));

    padding-left: 0.5rem;

    padding-right: 0.5rem;

    padding-top: 0.75rem;

    padding-bottom: 0.75rem
}

.sGD3wCcqTllAQDcolJFh {

    margin-top: 1rem;

    display: flex;

    height: 47px;

    width: 100%;

    align-items: center;

    gap: 1rem;

    border-radius: 5px;

    --tw-bg-opacity: 1;

    background-color: rgb(255 244 203 / var(--tw-bg-opacity, 1));

    padding-left: 0.5rem;

    padding-right: 0.5rem;

    padding-top: 1rem;

    padding-bottom: 1rem
}

.tJEpn13VhH23VU5wJQDy {

    font-family: Noto Sans;

    font-size: 12px;

    font-weight: 500;

    --tw-text-opacity: 1;

    color: rgb(153 27 27 / var(--tw-text-opacity, 1))
}

.Ni3_LQ8C0ABkacBDYEAh {

    font-family: Noto Sans;

    font-size: 12px;

    font-weight: 500;

    --tw-text-opacity: 1;

    color: rgb(164 133 10 / var(--tw-text-opacity, 1))
}

.fnf4EsGDx5fE429D7NLV {

    height: 34px;

    width: 34px;

    border-radius: 5px;

    -o-object-fit: contain;

       object-fit: contain
}
`, "",{"version":3,"sources":["webpack://./src/components/WarningMessage/warningMessage.module.css"],"names":[],"mappings":"AACE;;IAAA,gBAAsF;;IAAtF,aAAsF;;IAAtF,wBAAsF;;IAAtF,mBAAsF;;IAAtF,WAAsF;;IAAtF,mBAAsF;;IAAtF,SAAsF;;IAAtF,kBAAsF;;IAAtF,kBAAsF;;IAAtF,4DAAsF;;IAAtF,oBAAsF;;IAAtF,qBAAsF;;IAAtF,oBAAsF;;IAAtF;AAAsF;;AAItF;;IAAA,gBAA4F;;IAA5F,aAA4F;;IAA5F,YAA4F;;IAA5F,WAA4F;;IAA5F,mBAA4F;;IAA5F,SAA4F;;IAA5F,kBAA4F;;IAA5F,kBAA4F;;IAA5F,4DAA4F;;IAA5F,oBAA4F;;IAA5F,qBAA4F;;IAA5F,iBAA4F;;IAA5F;AAA4F;;AAI5F;;IAAA,sBAAmE;;IAAnE,eAAmE;;IAAnE,gBAAmE;;IAAnE,oBAAmE;;IAAnE;AAAmE;;AAInE;;IAAA,sBAA4E;;IAA5E,eAA4E;;IAA5E,gBAA4E;;IAA5E,oBAA4E;;IAA5E;AAA4E;;AAI5E;;IAAA,YAAqD;;IAArD,WAAqD;;IAArD,kBAAqD;;IAArD,sBAAqD;;OAArD;AAAqD","sourcesContent":[".approvalRequirementItem {\n  @apply w-full bg-danger-700 h-fit mt-4 px-2 rounded-[5px] items-center flex gap-4 py-3;\n}\n\n.warningContainer {\n  @apply w-full bg-warningCardBG h-[47px] mt-4 px-2 rounded-[5px] items-center flex gap-4 py-4;\n}\n\n.deleteText {\n  @apply text-red-800 font-dashboardMain text-dashboardSub font-inter;\n}\n\n.warningText {\n  @apply text-warningTextColor font-dashboardMain text-dashboardSub font-inter;\n}\n\n.deleteIcon {\n  @apply w-[34px] h-[34px] object-contain rounded-[5px];\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"approvalRequirementItem": `BJ9rbX6kOApAQ1TI_wmw`,
	"warningContainer": `sGD3wCcqTllAQDcolJFh`,
	"deleteText": `tJEpn13VhH23VU5wJQDy`,
	"warningText": `Ni3_LQ8C0ABkacBDYEAh`,
	"deleteIcon": `fnf4EsGDx5fE429D7NLV`
};
export default ___CSS_LOADER_EXPORT___;
